import ecoRebatesActionTypes from '../actionTypes/EcoRebatesActionTypes';

const getEcoRebates = (payload) => ({
    type: ecoRebatesActionTypes.SITE_ECOREBATES_GET_REQUEST,
    payload,
});

const getBundleEcoRebates = (payload) => ({
    type: ecoRebatesActionTypes.BUNDLE_ECOREBATES_GET_REQUEST,
    payload,
});

const openEcoRebatesModal = (sourceMiniPDP = false) => ({
    type: ecoRebatesActionTypes.SITE_ECOREBATES_MODAL_OPEN,
    payload: {
        openModal: true,
        sourceMiniPDP,
    },
});

const closeEcoRebatesModal = (sourceMiniPDP = false) => ({
    type: ecoRebatesActionTypes.SITE_ECOREBATES_MODAL_CLOSE,
    payload: {
        openModal: false,
        sourceMiniPDP,
    },
});

const resetEcoRebates = (sourceMiniPDP = false) => ({
    type: ecoRebatesActionTypes.SITE_ECOREBATES_RESET,
    sourceMiniPDP,
});

export default {
    getEcoRebates,
    getBundleEcoRebates,
    closeEcoRebatesModal,
    openEcoRebatesModal,
    resetEcoRebates,
};
